import React from 'react';
import { motion } from 'framer-motion'; // Import framer-motion for animations
import Image1 from '../assets/home/green-orchid-villas.jpg'; // Example images
import Image2 from '../assets/home/sandalwood.png';
import Image3 from '../assets/home/urban-heights.jpg';

const OnGoingProjects = () => {
  // Updated data for completed plot projects
  const plotProjects = [
    {
      title: "Farming land in Addanki",
      description:
        "Fertile farming land with ideal climate, irrigation, and easy access for diverse crop cultivation.",
      image: Image2,
      location: "Addanki",
      plots: 150,
      totalSqFeet: "22.7",
      year: 2024,
    },
    {
      title: "Vajram",
      description: "A prime location expansion with plots suitable for mixed-use development.",
      image: Image1,
      location: "Tadikonda",
      plots: 75,
      totalSqFeet: "15",
      year: 2024,
    },
    // {
    //   title: "Downtown Heights Expansion",
    //   description:
    //     "A prime location expansion with plots suitable for mixed-use development.",
    //   image: Image3,
    //   location: "Downtown Heights",
    //   plots: 90,
    //   totalSqFeet: "85,000",
    //   year: 2026,
    // },
    // Duplicate entries for demo purposes
    // {
    //   title: 'Tech City Development',
    //   description: 'A large-scale development with numerous plots for residential and commercial use.',
    //   image: Image1,
    //   location: 'Tech City',
    //   plots: 150,
    //   totalSqFeet: '100,000',
    //   year: 2024,
    // },
    // {
    //   title: 'Greenfield Estates',
    //   description: 'An eco-friendly community with a focus on sustainability and green spaces.',
    //   image: Image2,
    //   location: 'Greenfield',
    //   plots: 75,
    //   totalSqFeet: '60,000',
    //   year: 2025,
    // },
    // {
    //   title: 'Downtown Heights Expansion',
    //   description: 'A prime location expansion with plots suitable for mixed-use development.',
    //   image: Image3,
    //   location: 'Downtown Heights',
    //   plots: 90,
    //   totalSqFeet: '85,000',
    //   year: 2026,
    // },
  ];

  return (
    <section id="upcoming-plot-projects" className="bg-gray-50 py-16 lg:py-24">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Animated Header Text */}
        <motion.h2
          className="text-3xl lg:text-4xl font-extrabold text-gray-800 mb-12 text-center"
          initial={{ opacity: 0, y: -30 }} // Start position
          whileInView={{ opacity: 1, y: 0 }} // When in view, trigger animation
          transition={{ duration: 1 }} // Animation duration
          viewport={{ once: true }} // Trigger animation once when in view
        >
          On Going Projects
        </motion.h2>

        {/* Grid of Plot Projects */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {plotProjects.map((project, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg"
              initial={{ opacity: 0, y: 30 }} // Start position
              whileInView={{ opacity: 1, y: 0 }} // When in view, trigger animation
              transition={{ duration: 1, delay: index * 0.2 }} // Delay for staggered effect
              viewport={{ once: true }} // Trigger animation once when in view
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-72 object-cover rounded-t-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {project.title}
              </h3>
              <p className="text-gray-600 mb-4">{project.description}</p>
              <div className="text-gray-700 mb-4">
                <p>
                  <strong>Location:</strong> {project.location}
                </p>
                {/* <p>
                  <strong>No of Plots:</strong> {project.plots}
                </p> */}
                <p>
                  <strong>Total Acres:</strong> {project.totalSqFeet}
                </p>
                <p>
                  <strong>Year:</strong> {project.year}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default OnGoingProjects;
